/* eslint-disable */
import { useState, useEffect } from 'react';
import { Paper, Typography, TextField, Button, Box } from '@mui/material';
import { cashDepositBanksApi, fetchBankListAPi } from 'utils/API/Merchant APIs/AepsApiCalls';
import { handleCatchError } from 'utils/CatchHandler';
import Autocomplete from '@mui/material/Autocomplete';
import hdfc from '../../../../assets/images/Banks/hdfc.png';
import kotak from '../../../../assets/images/Banks/kotak.png';
import federal from '../../../../assets/images/Banks/federal.png';
import sbi from '../../../../assets/images/Banks/sbi.png';
import Tooltip from '@mui/material/Tooltip';
import { motion } from 'framer-motion';
import { useDispatch } from 'react-redux';
import { setResetTrue } from '../../../../redux/ResetSlice';

export default function TransactionDetails({
    aadhaarNumber,
    setAadhaarNumber,
    bank,
    setBank,
    amount,
    setAmount,
    mobileNumber,
    setMobileNumber,
    showAmount,
    tabIndex,
    setFetchedBankList,
    aadhaarError,
    setAadhaarError,
    mobileError,
    setMobileError,
    amountError,
    setAmountError
}) {
    const [bankList, setBankList] = useState([]);
    const [bankValue, setBankValue] = useState('');
    const [mostUsedBanksList, setMostUsedBanksList] = useState([]);

    const dispatch = useDispatch();

    useEffect(() => {
        const fetchBanks = async () => {
            try {
                let response;
                if (tabIndex === 3) {
                    response = await cashDepositBanksApi();
                } else {
                    response = await fetchBankListAPi();
                }
                const fetchedBanks = response?.data?.data || [];
                const banks = JSON.parse(JSON.stringify(fetchedBanks));
                setMostUsedBanksList(fetchedBanks);
                setBankList(banks);
                const bankOrderMap = new Map();
                response?.data?.most_used_banks.forEach((item, index) => {
                    bankOrderMap.set(item.bank_name, index);
                });

                banks.sort((a, b) => {
                    const indexA = bankOrderMap.has(a.bankName) ? bankOrderMap.get(a.bankName) : Infinity;
                    const indexB = bankOrderMap.has(b.bankName) ? bankOrderMap.get(b.bankName) : Infinity;
                    return indexA - indexB;
                });

                banks.slice(0, 5).forEach((bank) => {
                    bank.bankName = `⭐ ${bank.bankName}`;
                });
            } catch (e) {
                console.error(e.message);
                if (typeof handleCatchError === 'function') handleCatchError(e);
            }
        };

        fetchBanks();
    }, []);

    const handleAadharChange = (e) => {
        const value = e.target.value.replace(/[^\d]/g, '').slice(0, 12);
        setAadhaarNumber(value);
        setAadhaarError(value.length === 12 ? '' : 'Aadhaar number must be 12 digits');
    };

    const handleMobileChange = (e) => {
        let mobileVal = e.target.value.replace(/[^\d]/g, '');
        if (mobileVal.length > 0 && !['6', '7', '8', '9'].includes(mobileVal[0])) {
            mobileVal = '';
        }
        mobileVal = mobileVal.slice(0, 10);
        setMobileNumber(mobileVal);
        setMobileError(mobileVal.length === 10 ? '' : 'Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9');
    };

    const handleAmountChange = (e) => {
        let rawValue = e.target.value.replace(/[^\d]/g, '').slice(0, 6);
        if (rawValue.startsWith('0')) {
            rawValue = rawValue.replace(/^0+/, '');
        }
        const value = rawValue ? parseInt(rawValue, 10) : '';
        setAmount(rawValue);
        if (!rawValue) {
            setAmountError('Amount is required');
        } else if (value < 100) {
            setAmountError('Minimum amount should be ₹100');
        } else if (value % 50 !== 0) {
            setAmountError('Amount must be a multiple of ₹50');
        } else {
            setAmountError('');
        }
    };

    function handleBankChange(event, newValue) {
        setBankValue(newValue);
        setBank(newValue);
    }
    const mostPopularBanksShortForm = {
        'State Bank of India': 'SBI',
        'Federal Bank': 'Federal',
        'HDFC Bank': 'HDFC',
        'Kotak Mahindra Bank': 'Kotak'
    };
    const bankImage = {
        hdfc,
        kotak,
        federal,
        sbi
    };
    const mostUsedBanks = mostUsedBanksList?.filter((b) => Object.keys(mostPopularBanksShortForm).includes(b.bankName));

    const handleReset = () => {
        dispatch(setResetTrue()); // This should set isReset to true
        setAadhaarNumber('');
        setAadhaarError('');
        setBank('');
        setBankValue('');
        setAmount('');
        setAmountError('');
        setMobileNumber('');
        setMobileError('');
    };
    return (
        <Paper elevation={3} sx={{ p: 3 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="subtitle1" fontWeight="bold">
                    Transaction Details
                </Typography>
                <Button variant="outlined" size="small" color="error" onClick={handleReset}>
                    Reset
                </Button>
            </Box>

            <TextField
                fullWidth
                label="Aadhaar Number *"
                value={aadhaarNumber}
                onChange={handleAadharChange}
                margin="normal"
                inputProps={{ maxLength: 12 }}
                error={Boolean(aadhaarError)}
                helperText={aadhaarError}
            />

            <TextField
                fullWidth
                label="Mobile Number"
                value={mobileNumber}
                onChange={handleMobileChange}
                margin="normal"
                required
                sx={{ mb: 3 }}
                inputProps={{ maxLength: 10 }}
                error={Boolean(mobileError)}
                helperText={mobileError}
            />

            <Autocomplete
                disablePortal
                id="combo-box-demo"
                value={bankValue ? bankValue : null}
                options={bankList || []}
                onChange={handleBankChange}
                getOptionLabel={(option) => option?.bankName?.replace(/^⭐\s*/, '') || ''}
                renderOption={(props, option) => (
                    <Box component="li" {...props}>
                        {option.bankName}
                    </Box>
                )}
                sx={{ width: '100%', mb: 1 }}
                renderInput={(params) => <TextField {...params} label="Select Bank *" />}
            />

            <Typography variant="subtitle2" mt={2} mb={1}>
                Most popular Banks
            </Typography>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between'
                }}
            >
                {mostUsedBanks.map((b) => {
                    const shortName = mostPopularBanksShortForm[b.bankName];
                    const imageKey = shortName.toLowerCase();
                    const normalizeName = (name) => name?.replace(/^⭐\s*/, '');
                    const isSelected = normalizeName(bank?.bankName) === b?.bankName;

                    return (
                        <Box
                            key={b.iinno || b.bankName}
                            sx={{
                                flexBasis: '25%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                mb: 2
                            }}
                        >
                            <Tooltip title={b.bankName}>
                                <motion.div
                                    whileHover={{ scale: 1.1, rotate: 1 }}
                                    whileTap={{ scale: 0.95 }}
                                    style={{ display: 'flex', borderRadius: 4 }}
                                >
                                    <Button
                                        variant={isSelected ? 'contained' : 'outlined'}
                                        onClick={() => {
                                            setBank(b);
                                            setBankValue(b);
                                        }}
                                        sx={{
                                            color: isSelected ? '#fff' : '#1b0e52',
                                            borderColor: '#1b0e52',
                                            background: isSelected ? 'linear-gradient(135deg, rgb(25, 26, 27), #1976D2)' : 'transparent',
                                            width: '80px',
                                            height: '50px',
                                            px: 1.5,
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            '&:hover': {
                                                background: isSelected ? 'linear-gradient(135deg, rgb(25, 26, 27), #1976D2)' : '#f2f2f2'
                                            }
                                        }}
                                    >
                                        <img
                                            src={bankImage[imageKey]}
                                            alt={shortName}
                                            style={{ width: 65, height: 32, objectFit: 'contain' }}
                                        />
                                    </Button>
                                </motion.div>
                            </Tooltip>
                            <Typography variant="caption" fontWeight={500} sx={{ color: isSelected ? '#1976D2' : '#1b0e52', mt: 0.5 }}>
                                {shortName}
                            </Typography>
                        </Box>
                    );
                })}
            </Box>

            {showAmount && (
                <TextField
                    fullWidth
                    label="Amount"
                    value={amount}
                    onChange={handleAmountChange}
                    margin="normal"
                    type="text" // changed from "number" to "text"
                    InputProps={{
                        startAdornment: <Typography sx={{ mr: 1 }}>₹</Typography>
                    }}
                    error={Boolean(amountError)}
                    helperText={amountError}
                />
            )}
        </Paper>
    );
}
